/**
 * Converts a YouTube or Vimeo share/watch URL into its embeddable player URL.
 * Returns null for anything else — callers should not render an iframe then.
 */
export function toVideoEmbedUrl(url: string): string | null {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }

  const host = parsed.hostname.replace(/^www\./, '');

  if (host === 'youtube.com' || host === 'm.youtube.com') {
    if (parsed.pathname === '/watch') {
      const videoId = parsed.searchParams.get('v');
      return videoId
        ? `https://www.youtube-nocookie.com/embed/${videoId}`
        : null;
    }
    const embedMatch = parsed.pathname.match(/^\/(embed|shorts)\/([\w-]+)/);
    return embedMatch
      ? `https://www.youtube-nocookie.com/embed/${embedMatch[2]}`
      : null;
  }

  if (host === 'youtu.be') {
    const videoId = parsed.pathname.slice(1).split('/')[0];
    return videoId ? `https://www.youtube-nocookie.com/embed/${videoId}` : null;
  }

  if (host === 'vimeo.com') {
    const videoId = parsed.pathname.slice(1).split('/')[0];
    return /^\d+$/.test(videoId)
      ? `https://player.vimeo.com/video/${videoId}`
      : null;
  }

  if (host === 'player.vimeo.com') {
    const videoMatch = parsed.pathname.match(/^\/video\/(\d+)/);
    return videoMatch ? `https://player.vimeo.com/video/${videoMatch[1]}` : null;
  }

  return null;
}
